import { Injectable } from '@angular/core';
import { IAsyncTaskReport, ITask } from '@core/components/async-tasks/async-task-reports/async-task-constants';
import { AbstractAsyncTaskReport } from '@core/components/async-tasks/async-task-reports/abstract-async-task.report';

interface IDuplicateCustomerRefError {
  [customer_ref: string]: number[];
}

@Injectable({
  providedIn: 'root'
})
export class EntityBulkUpdateReport extends AbstractAsyncTaskReport implements IAsyncTaskReport {
  public generate(task: ITask): string {
    if (task.status === 'success') {
      let htmlDetail = `<div>Mise à jour des entités effectuée avec succès.<br></div>`;
      htmlDetail += this.formatEntityBulkUpdateSuccess(task.detail);
      return htmlDetail;
    } else {
      let htmlDetail: string = '<div>Erreur lors de la mise à jour.<br></div>';
      htmlDetail += this.formatOnlyStructureAndContentImportError(task.detail, {
        INVALID_FILE_CONTENT_DUPLICATE: this._handleDuplicateCustomerRefErrors.bind(this),
      });
      return htmlDetail;
      }
  }

  private formatEntityBulkUpdateSuccess(detail): string {
    if (!detail) {
      return '';
    }
    const downloadUrl = this.apiShiva.attachments.downloadUrl(detail.attachment_id);
    return `
      ${detail.detail}<br><br>
      <ul>
        <li>
          <a href="${downloadUrl}" class="btn btn-default" target="_blank">
            <i class="far fa-file-excel" aria-hidden="true"></i>
            Télécharger le rapport
          </a>
        </li>
      </ul>
    `;
  }

  private _handleDuplicateCustomerRefErrors(error: IDuplicateCustomerRefError): string {
    let errorString = `Certaines réfs clients sont dupliquées pour un même groupement dans le fichier:`;
    errorString += '<ul>';

    errorString += error.error_detail.map((customerRef) => {
      return `<li> Références client déja existantes ${customerRef}</li>`;
    });
    errorString += '</ul>';
    return errorString;
  }
}
